import request from '@/utils/request'

export function fetchKeys() {
  return request.get('/api/keys')
}

export function createKey(data) {
  return request.post('/api/keys', data)
}

export function updateKey(id, data) {
  return request.put(`/api/keys/${id}`, data)
}

export function deleteKey(id) {
  return request.delete(`/api/keys/${id}`)
}

export function deleteExpiredKeys() {
  return request.delete('/api/keys/expired')
}
